import { createSelector } from "reselect";
import { patientEvaluationsConfiguration } from "src/constants/filters_configurations/compliance";

export const patientUserFilterConfigSelector = createSelector(
  () => patientEvaluationsConfiguration
);
